import { render } from "./Profile.vue?vue&type=template&id=05afa506&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=05afa506&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Register\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05afa506"]])

export default __exports__